import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import newOrderService from './service';

export const useNewOrderWithKeys = getUseServiceWithSubscriptionKeys(newOrderService);

export { newOrderService };
